import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Restricts a route to owners.
 *
 * This is NOT the security boundary — every expense endpoint calls requireOwner() on
 * the server, and the collections behind them are NO_ACCESS so they cannot be reached
 * through the generic schema route either. A tampered localStorage role gets past this
 * guard and is then rejected by the backend.
 *
 * What it buys is that a staff member who follows a bookmarked URL lands somewhere
 * usable instead of on a screen that renders empty and then fills with "Only an owner
 * can perform this action". Hiding the nav item alone does not cover that path, which
 * is why the gate is on the route and not just the menu.
 */
export const ownerGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!auth.isAuthenticated()) return router.parseUrl('/login');
  return auth.isOwner() ? true : router.parseUrl('/dashboard');
};
